import { Icon } from "components/common/Icon";
import { RepaymentDetails } from "components/common/RepaymentDetails";
import {
  REPAYMENT_HOLIDAY_OPTION_CRH_TEXT,
  REPAYMENT_HOLIDAY_OPTION_CIRH_TEXT,
  CRH,
  CIRH,
  IMPORTANT_INFO_NOTES,
  IMPORTANT_INFO_NOTE,
} from "components/RequestRepaymentHoliday/RequestRepaymentHoliday.const";
import { RepaymentHolidaysType } from "domain/selectedTreatments";
import { SelectedTreatmentsDetails } from "domain/selectedTreatments";
import checkboxtickSVG from "../../assets/tick.svg";
import { displayOptionsSubHeading, getCheckBoxText } from "domain/appSummary";
import { IndicativeCalculationBanner } from "components/common/IndicativeCalculationBanner";
import { ParagraphText } from "components/common/ParagraphText";
import {
  RepaymentOption,
  RepaymentOptionType,
} from "domain/indicativeRepaymentOptions";

const displayHolidayOptionSubHeading = (
  selectedOptionType: RepaymentHolidaysType
) => {
  switch (selectedOptionType) {
    case RepaymentHolidaysType.CapitalRepaymentHoliday:
      return (
        <>
          <div className="appHeader">{CRH}</div>
          <div>{REPAYMENT_HOLIDAY_OPTION_CRH_TEXT}</div>
        </>
      );
    case RepaymentHolidaysType.CapitalIntersestRepaymentHoliday:
      return (
        <>
          <div className="appHeader">{CIRH}</div>
          <div>{REPAYMENT_HOLIDAY_OPTION_CIRH_TEXT}</div>
        </>
      );
    default:
      return <></>;
  }
};

const displayImportantInfoNotes = (repaymentOption: RepaymentOption) =>
  repaymentOption.optionType === RepaymentOptionType.CRHExtendTerm ? (
    <ParagraphText list={IMPORTANT_INFO_NOTES} />
  ) : (
    <p>{IMPORTANT_INFO_NOTE}</p>
  );

type RequestRepaymentHolidaySummaryProps = {
  selectedTreatments: SelectedTreatmentsDetails;
};

export const RequestRepaymentHolidaySummary = ({
  selectedTreatments,
}: RequestRepaymentHolidaySummaryProps) => {
  const { repaymentOption, selectedOptionType, selectedRHType } =
    selectedTreatments;
  return (
    <>
      {!!repaymentOption && selectedOptionType && (
        <>
          <div className="option-heading">
            {displayHolidayOptionSubHeading(selectedRHType!)}
          </div>
          <div className="appHeader">
            {displayOptionsSubHeading(repaymentOption.optionType)}
          </div>
          <RepaymentDetails
            repaymentOption={repaymentOption}
            existingLoanDetails={selectedTreatments.existingLoanDetails!}
          />
          {displayImportantInfoNotes(repaymentOption)}
          <IndicativeCalculationBanner />
          <div className="chk-box">
            <Icon
              icon={checkboxtickSVG}
              width={19}
              alt="Checkbox Tick Icon"
              title={getCheckBoxText(repaymentOption.optionType)}
            />
          </div>
        </>
      )}
    </>
  );
};
